import { useEffect, useState } from "react";
import { toast } from "sonner";
import { usePreIfrSettings, useSavePreIfrSettings } from "@/lib/api";
import { PrimaryButton, Select } from "@/pages/SuperAdmin/primitives";

// Which workshop's people the Pre-IFR escalation steps reach. Tata's job cards do not say which
// workshop they belong to yet, so every one is given the workshop chosen here.
export default function PreIfrWorkshop({ tenantId }) {
  const { data } = usePreIfrSettings(tenantId);
  const save = useSavePreIfrSettings(tenantId);
  const [choice, setChoice] = useState("");

  const saved = data?.workshop_location || "";
  useEffect(() => setChoice(saved), [saved]);

  if (!data) return null;

  const onSave = async () => {
    try {
      const result = await save.mutateAsync({ workshop_location: choice });
      const n = result?.job_cards_updated || 0;
      toast.success(n ? `Workshop saved. ${n} job card${n === 1 ? "" : "s"} updated.` : "Workshop saved.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save the workshop.");
    }
  };

  return (
    <div data-testid="pre-ifr-workshop" className="mb-6 border-b border-[#F2F4F7] pb-6">
      <div className="text-[14px] font-semibold text-[#101828]">Workshop for escalations</div>
      <div className="mt-3 flex items-center gap-3">
        <Select
          className="w-[280px]"
          value={choice}
          onChange={(e) => setChoice(e.target.value)}
          aria-label="Workshop for escalations"
        >
          <option value="">Choose a workshop</option>
          {(data.workshops || []).map((w) => (
            <option key={w} value={w}>
              {w}
            </option>
          ))}
        </Select>
        <PrimaryButton onClick={onSave} disabled={save.isPending || choice === saved}>
          Save
        </PrimaryButton>
      </div>
      {!saved && (
        <p data-testid="pre-ifr-workshop-warning" className="mt-3 text-[13px] text-[#B54708]">
          No workshop is chosen, so steps that go to a role have nobody to reach until you choose one.
        </p>
      )}
    </div>
  );
}
